import React from 'react';
import {style, classes} from './doppe-action-type-widget-inner-button.st.css';
import {Button, DoubleRingSpinner} from "@wix/devzai-utils-react";

export const DoppeActionTypeWidgetInnerButton = React.memo(function DoppeActionTypeWidgetInnerButton (props: DoppeActionTypeWidgetInnerButton.Props) {
    const {
        isLoading,
        children,
        disabled,
        inPopup = false,

        className,
        ...htmlAttributes
    } = props;

    return (
        <Button
            {...htmlAttributes}
            className={style(classes.root, {inPopup: inPopup}, className)}
            disabled={disabled || isLoading}
        >
            {children}
            {isLoading ? (
                <div
                    className={style(classes.loadingState, {})}
                >
                    <DoubleRingSpinner
                        className={style(classes.spinner, {})}
                    />
                    {'Please Wait...'}
                </div>
            ) : null}
        </Button>
    );
});

export namespace DoppeActionTypeWidgetInnerButton {

    export interface Props extends Button.Props {
        isLoading?: boolean;
        inPopup?: boolean;
    }
}
